import React, { useContext, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { isView } from '../../../../core/page/components/baseForm/BaseForm';
import Pages from '../../../../config/Pages';
import Shareds from '../../../../config/translations/Shareds';
import styles from './IndicadorForm.module.scss';
import MultipageIndicador from '../components/MultipageIndicador';
import EstruturaIndicador, {
    indicadorNavItems,
} from '../../components/estruturaIndicador/EstruturaIndicador';
import MultipageProposta from '../../propostaIndicador/components/MultipageProposta';
import { ApplicationContext } from '../../../../config/Router';
import { Card } from 'primereact/card';
import CardHeaderProposta from '../../components/cardHeaderProposta/CardHeaderProposta';

function IndicadorForm() {
    const { id } = useParams();
    const { proposta } = useContext(ApplicationContext);
    const history = useHistory();
    const multipagePropostaRef = useRef(null);

    return (
        <EstruturaIndicador
            selected={
                isView() ? indicadorNavItems.dadosIndicador : indicadorNavItems.alterarIndicador
            }
        >
            <Card>
                <h5>
                    <strong>{`${Pages.sei.indicador.title} - `}</strong>
                    <small>
                        {isView() ? Shareds.form.actions.view : Shareds.form.actions.update}
                    </small>
                </h5>
                <hr />
                {isView() ? (
                    <MultipageIndicador idProposta={id} className={styles.card} isView={isView()} />
                ) : (
                    <>
                        <CardHeaderProposta
                            proposta={proposta}
                            multipagePropostaRef={multipagePropostaRef}
                            onRemove={() => history.push(Pages.sei.indicador.url.list)}
                            onCancelar={() => history.push(Pages.sei.indicador.url.list)}
                        />
                        <MultipageProposta
                            ref={multipagePropostaRef}
                            disableButtonEnviar={
                                proposta?.situacaoProposta?.codgSituacaoProposta !== 'CADASTRO' &&
                                proposta?.situacaoProposta?.codgSituacaoProposta !==
                                    'REVISAR_PROPOSTA'
                            }
                            idProposta={proposta?.id}
                            idIndicador={id}
                            className={styles.card}
                            isView={isView()}
                            voltarUrl={Pages.sei.indicador.url.list}
                            onEnviar={() =>
                                history.push(Pages.sei.indicador.url.list.replace(':id', id))
                            }
                        />
                    </>
                )}
            </Card>
        </EstruturaIndicador>
    );
}

export default IndicadorForm;
